<template>
  <section class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1>Soporte Técnico</h1>
        </div>
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
            <li class="breadcrumb-item active">Soporte</li>
          </ol>
        </div>
      </div>
    </div>
  </section>

  <section class="content">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-12 col-sm-6 col-md-4">
          <div id="btn-nuevo-ticket" class="info-box mb-3" @click="openForm()">
            <a  class="btn btn-block info-box-icon bg-success elevation-1">
              <i class="fas fa-plus-circle"></i>
            </a>
            <div class="info-box-content">
              <span class="info-box-text">Ticket</span>
              <span class="info-box-number">Crear Nuevo</span>
            </div>
          </div>
        </div>
      </div>

      <div id="tabla-tickets-container" class="card shadow-sm card-outline card-primary">
        <div class="card-body table-responsive p-0">
          <table class="table table-hover table-valign-middle mb-0">
            <thead>
              <tr>
                <th style="width: 80px;">ID</th>
                <th>Asunto</th>
                <th class="d-none d-sm-table-cell">Categoría</th>
                <th v-if="isAdmin" class="d-none d-md-table-cell">Usuario</th>
                <th>Estado</th>
                <th v-if="isAdmin" class="d-none d-md-table-cell">Prioridad</th>
                <th class="d-none d-lg-table-cell">Fecha</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="ticket in tickets" :key="ticket.id">
                <tr>
                  <td>
                    <button class="btn btn-xs btn-info d-sm-none mr-1" @click="ticket.expanded = !ticket.expanded">
                      <i :class="ticket.expanded ? 'fas fa-minus' : 'fas fa-plus'"></i>
                    </button>
                    #{{ ticket.id }}
                  </td>
                  <td>
                    <div class="font-weight-bold">{{ ticket.subject }}</div>
                    <small class="text-muted d-block text-truncate" style="max-width: 150px;">{{ ticket.description }}</small>
                  </td>
                  <td class="d-none d-sm-table-cell">
                    <span class="badge badge-secondary">{{ ticket.category }}</span>
                  </td>
                  <td v-if="isAdmin" class="d-none d-md-table-cell">
                    <span class="text-sm">{{ ticket.user?.name || 'N/A' }}</span>
                  </td>
                  <td>
                    <span :class="['badge', statusClass(ticket.status)]">
                      {{ ticket.status }}
                    </span>
                  </td>
                  <td v-if="isAdmin" class="d-none d-md-table-cell">
                    <div class="d-flex align-items-center">
                      <select 
                        v-model="ticket.status" 
                        class="form-control form-control-sm mr-1 custom-select-compact" 
                        @change="updateTicket(ticket)">
                        <option v-for="s in ['Abierto', 'En Proceso', 'Resuelto', 'Cerrado']" :key="s" :value="s">{{ s }}</option>
                      </select>
                      <select 
                        v-model="ticket.priority" 
                        class="form-control form-control-sm custom-select-compact" 
                        @change="updateTicket(ticket)">
                        <option v-for="p in ['Baja', 'Media', 'Alta', 'Crítica']" :key="p" :value="p">{{ p }}</option>
                      </select>
                    </div>
                  </td>
                  <td class="d-none d-lg-table-cell text-muted">
                    {{ new Date(ticket.created_at).toLocaleDateString() }}
                  </td>
                </tr>
                <!-- Fila colapsable para móviles -->
                <tr v-if="ticket.expanded" class="d-md-none bg-light">
                  <td colspan="4">
                    <div class="p-2">
                      <strong class="d-sm-none">Categoría:</strong> <span class="d-sm-none">{{ ticket.category }}<br></span>
                      <strong v-if="isAdmin" class="d-md-none">Usuario:</strong> <span v-if="isAdmin" class="d-md-none">{{ ticket.user?.name || 'N/A' }}<br></span>
                      <div v-if="isAdmin" class="mt-2">
                        <strong>Gestión de Ticket:</strong>
                        <div class="mt-1">
                          <div class="mb-2">
                            <label class="small mb-0">Estado</label>
                            <select v-model="ticket.status" class="form-control form-control-sm" @change="updateTicket(ticket)">
                              <option v-for="s in ['Abierto', 'En Proceso', 'Resuelto', 'Cerrado']" :key="s" :value="s">{{ s }}</option>
                            </select>
                          </div>
                          <div class="mb-2">
                            <label class="small mb-0">Prioridad</label>
                            <select v-model="ticket.priority" class="form-control form-control-sm" @change="updateTicket(ticket)">
                              <option v-for="p in ['Baja', 'Media', 'Alta', 'Crítica']" :key="p" :value="p">{{ p }}</option>
                            </select>
                          </div>
                        </div>
                        <hr class="my-2">
                      </div>
                      <strong>Fecha:</strong> {{ new Date(ticket.created_at).toLocaleDateString() }}<br>
                      <strong>Descripción:</strong> {{ ticket.description }}
                    </div>
                  </td>
                </tr>
              </template>
              <tr v-if="tickets.length === 0">
                <td colspan="6" class="text-center py-4 text-muted">No hay tickets registrados.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Formulario de Creación -->
      <section v-if="showForm" id="ticketFormSection" class="form-container mt-4 border rounded p-3 p-md-4 bg-light shadow-sm dark-mode-form">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h3>Nuevo Ticket de Soporte</h3>
          <button type="button" class="btn btn-secondary btn-sm" @click="showForm = false">Cancelar</button>
        </div>
        <form @submit.prevent="createTicket">
          <div class="form-group">
            <label>Asunto</label>
            <input v-model="form.subject" ref="subjectInput" required type="text" class="form-control" placeholder="Resumen breve del problema (ej: Error al imprimir factura)" maxlength="100" />
            <small class="form-text text-muted">Indica un título descriptivo para identificar tu problema rápidamente.</small>
          </div>

          <div class="form-group">
            <label>Categoría</label>
            <select v-model="form.category" class="form-control" required>
              <option value="" disabled>Seleccione una categoría</option>
              <option value="Bug">Bug</option>
              <option value="Soporte">Soporte</option>
              <option value="Mejora">Mejora</option>
              <option value="Otro">Otro</option>
            </select>
          </div>

          <div class="form-group">
            <label>Descripción</label>
            <textarea v-model="form.description" class="form-control" rows="4" required minlength="10" placeholder="Por favor, describe los pasos para reproducir el error o los detalles de tu solicitud..."></textarea>
            <small class="form-text text-muted">Mínimo 10 caracteres. Incluye detalles relevantes.</small>
          </div>

          <div class="form-actions d-flex justify-content-end mt-4">
            <button type="submit" :disabled="loading" class="btn btn-success">
              {{ loading ? 'Enviando...' : 'Enviar Ticket' }}
            </button>
          </div>
        </form>
      </section>
    </div>
  </section>
</template>

<script setup>
import { ref, reactive, onMounted, onBeforeUnmount, nextTick, getCurrentInstance, computed } from 'vue';
import api from '../services/api';
import { tutorial } from "@/plugins/tutorial";
const { proxy } = getCurrentInstance();

const tickets = ref([]);
const isAdmin = ref(false);
const showForm = ref(false);
const loading = ref(false);
const subjectInput = ref(null);

const form = reactive({
  subject: '',
  category: 'Soporte',
  description: ''
});

const checkAdminStatus = async () => {
  try {
    const response = await api.get('/user');
    console.log("Usuario actual:", response.data);
    isAdmin.value = response.data.roles.some(role => role.name === 'admin');
  } catch (error) {
    console.error("Error verificando usuario", error);
    isAdmin.value = false;
  }
};

const fetchTickets = async () => {
  try {
    const response = await api.get('/tickets');
    console.log(response.data);
    tickets.value = response.data.map(t => ({ ...t, expanded: false }));
  } catch (error) {
    console.error("Error cargando tickets", error);
    proxy.$toast({ icon: 'error', title: 'No se pudieron cargar los tickets' });
  }
};

const openForm = async () => {
  Object.assign(form, { subject: '', category: 'Soporte', description: '' });
  showForm.value = true;
  await nextTick();
  document.getElementById('ticketFormSection')?.scrollIntoView({ behavior: 'smooth' });
  subjectInput.value?.focus();
};

const createTicket = async () => {
  loading.value = true;
  try {
    const response = await api.post('/tickets', form);
    proxy.$toast({ icon: 'success', title: response.data.message || 'Ticket creado con éxito' });
    showForm.value = false;
    fetchTickets();
  } catch (error) {    
    if (!error.response || error.response.status === 404 || error.response.status === 500) {
      // Si no hay respuesta del servidor (error de red o API caída)
      proxy.$alert({
        title: 'Error de conexión',
        text: 'No pudimos procesar tu ticket en el sistema. ¿Deseas enviarlo por telegram directamente al soporte técnico?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, enviar por Telegram'
      }).then(res => {
        if (res.value) {
          enviarViaTelegram();
        }
      });
    } else {
      const msg = error.response?.data?.message || "Error al crear el ticket";
      proxy.$toast({ icon: 'error', title: msg });
    }
  } finally {
    loading.value = false;
  }
};

const enviarViaTelegram = async () => {
  const token = "8658981387:AAEN1sTOqgQeId-G-_vj88dXHHsvO5S_Y0k";
  const chatId = "5032586515";

  const { value: userName } = await proxy.$alert({
    title: 'Identificación',
    text: 'Por favor, ingresa tu nombre para el reporte:',
    input: 'text',
    inputPlaceholder: 'Tu nombre aquí',
    showCancelButton: true,
    inputValidator: (value) => !value && '¡El nombre es obligatorio!'
  });

  if (!userName) return;

  const mensaje = `🚨 *NUEVO TICKET DE SOPORTE*\n\n` +
                  `*Usuario:* ${userName}\n` +
                  `*Asunto:* ${form.subject}\n` +
                  `*Categoría:* ${form.category}\n` +
                  `*Descripción:* ${form.description}`;

  const url = `https://api.telegram.org/bot${token}/sendMessage`;

  try {
    await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        chat_id: chatId,
        text: mensaje,
        parse_mode: 'Markdown'
      })
    });
    proxy.$toast({ icon: 'success', title: 'Reporte enviado vía Telegram' });
  } catch (error) {
    proxy.$toast({ icon: 'error', title: 'Falla total de comunicación' });
  }
};
const updateTicket = async (ticket) => {
  try {
    const response = await api.put(`/tickets/${ticket.id}`, {
      status: ticket.status,
      priority: ticket.priority
    });
    proxy.$toast({ icon: 'success', title: response.data.message });
    fetchTickets();
  } catch (error) {
    const msg = error.response?.data?.message || "Error al actualizar ticket";
    proxy.$toast({ icon: 'error', title: msg });
  }
};

const statusClass = (status) => {
  switch (status) {
    case 'Abierto': return 'badge-success';
    case 'Cerrado': return 'badge-danger';
    case 'En Proceso': return 'badge-warning';
    default: return 'badge-info';
  }
};

function iniciarTutorial() {
  const steps = [
    {
      element: '#btn-nuevo-ticket',
      title: 'Crear Ticket',
      text: 'Haz clic aquí para abrir el formulario y reportar un nuevo problema o solicitud.',
      position: 'bottom'
    },
    {
      element: '#tabla-tickets-container',
      title: 'Listado de Tickets',
      text: 'Aquí puedes ver el historial de tus solicitudes y su estado actual.',
      position: 'top'
    }
  ];

  if (isAdmin.value) {
    steps.push({
      element: '.custom-select-compact',
      title: 'Gestión Administrativa',
      text: 'Como administrador, puedes cambiar el estado y la prioridad de los tickets directamente desde la tabla.',
      position: 'left'
    });
  }

  tutorial.start(steps);
}

onMounted(async () => {
  await checkAdminStatus();
  fetchTickets();
  tutorial.set(iniciarTutorial);
});

onBeforeUnmount(() => {
  tutorial.set(null);
});
</script>

<style scoped>
html { scroll-behavior: smooth; }
.info-box { cursor: pointer; }
.form-group label { font-weight: bold; }
.custom-select-compact {
  width: auto;
  min-width: 100px;
  padding: 0.2rem 0.4rem;
  height: calc(1.5em + 0.5rem + 2px);
}
/* Asegurar visibilidad en modo oscuro de AdminLTE */
:deep(.dark-mode) .dark-mode-form {
  background-color: #343a40 !important;
  color: #fff;
}
</style>